import { Checkbox } from "@mui/material";
import { MouseEvent } from "react";
import { SelectionCheckboxState } from "./types";

interface SelectionCheckboxProps extends SelectionCheckboxState {
  onChange: () => void;
}

const stopPropagation = (event: MouseEvent<HTMLButtonElement>) => {
  event.stopPropagation();
};

const SelectionCheckbox = ({ checked, indeterminate, onChange }: SelectionCheckboxProps) => {
  return (
    <Checkbox
      size='small'
      checked={checked}
      indeterminate={indeterminate}
      onClick={stopPropagation}
      onFocus={(event) => event.stopPropagation()}
      onChange={(event) => {
        event.stopPropagation();
        onChange();
      }}
      sx={{ p: 0 }}
    />
  );
};

export default SelectionCheckbox;
